import type { OrderAddress } from '@/apis/orders';

interface Props {
  address: OrderAddress | undefined | null;
  email: string | undefined | null;
  customerName: string | undefined | null;
}

function Field({ label, value }: { label: string; value: string | null | undefined }) {
  return (
    <div className="rounded-xl border border-smoke px-4 py-3">
      <p className="mb-1 text-xs font-normal text-lightGray">{label}</p>
      <p className="truncate text-sm font-medium text-black">{value || '—'}</p>
    </div>
  );
}

export function ShippingInfoSection({ address, email, customerName }: Props) {
  return (
    <section>
      <h2 className="mb-3 text-lg font-semibold text-black">Customer Shipping Information</h2>
      <div className="grid grid-cols-3 gap-3">
        <Field label="Country" value={address?.country} />
        <Field label="Name" value={customerName} />
        <Field label="Company" value={address?.company} />
        <Field label="Email" value={email} />
        <Field label="Phone" value={address?.phone} />
        <Field label="Address" value={address?.addressLine1} />
        <Field label="City" value={address?.city} />
        <Field label="State" value={address?.state} />
        <Field label="Postal Code" value={address?.postalCode} />
      </div>
    </section>
  );
}
